// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';
import previewImageHelper from '../../../../../application/helpers/previewImageHelper';

export default class FormView extends JQueryView {
  cloneFileElement = {};

  constructor() {
    super('.simple_form');
    $('.form-control-wrapper').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
    }
  }

  @on({ event: 'click', selector: '.image-wrapper' })
  toggleOperationArea() {
    if ($('.image-tag').attr('src') == $('.image-tag-hidden').attr('src')) {
      $('.operation-delete').hide();
    } else {
      $('.operation-delete').show();
    }
    $('.operation-area').toggle();
  }

  @on({ event: 'click', selector: '.operation-upload' })
  chooseImage() {
    $('.choose-image').click();
  }

  @on({ event: 'change', selector: '.choose-image' })
  changeImage(event: any) {
    if ($('.operation-area').css('display') == 'block') {
      $('.operation-area').hide();
    }
    const fileElement = event.currentTarget;
    const sizeLimit = 1024 * 1024 * 5; // 制限サイズ 5M
    if (fileElement.files[0] && fileElement.files[0].size > sizeLimit) {
      alert('プロフィール画像を5MBバイト以下のサイズにしてください');
      fileElement.value = ''; // inputの中身をリセット
      return; // この時点で処理を終了する
    }

    if (fileElement.value === '') {
      fileElement.parentElement.append(this.cloneFileElement[fileElement.id]);
      fileElement.remove();
    } else {
      previewImageHelper($('.choose-image'), $('.image-tag'));
    }
  }

  @on({ event: 'click', selector: '.choose-image' })
  keepPreviousImage(event: any) {
    const fileElement = event.currentTarget;
    if (fileElement.value !== '') {
      this.cloneFileElement[fileElement.id] = fileElement.cloneNode(true);
    }
  }

  @on({ event: 'click', selector: '.operation-delete' })
  deleteAvatar() {
    $('.operation-area').toggle();
    $('#investor_angel_remove_avatar').val('1');
    $('.image-tag').attr('src', $('.image-tag-hidden').attr('src'));
  }
}
